module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Price-List"
  }, [_c('h4', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('select', {
    staticClass: "test-select_list_price form-control",
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_vm._l((_vm.values), function(item, index) {
    return [_c('option', {
      key: index,
      attrs: {
        "disabled": item.is_disabled
      },
      domProps: {
        "selected": index == _vm.defaultIndex,
        "value": item.is_disabled ? '' : index
      }
    }, [_vm._v(_vm._s(_vm._f("formatCurrency")(item.value, _vm.currency)) + " - " + _vm._s(item.type))])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05f95582!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/_partials/price-list.vue
// module id = 242
// module chunks = 1